import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
let RoombaRoomController = (_class = class RoombaRoomController extends Controller {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "graphql", _descriptor2, this);
    _initializerDefineProperty(this, "linkManager", _descriptor3, this);
    _initializerDefineProperty(this, "roombaMetrics", _descriptor4, this);
    _initializerDefineProperty(this, "roomsPolling", _descriptor5, this);
    _initializerDefineProperty(this, "featureConfig", _descriptor6, this);
    _initializerDefineProperty(this, "room", _descriptor7, this);
    _defineProperty(this, "refetchRoom", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.room = yield this.roomsPolling.fetchRoomById.perform(this.room.id);
      }
    }), {
      restartable: true
    }, "refetchRoom", null));
    _defineProperty(this, "toggleMaskMeetingNamesSettingTask", _buildTask(() => ({
      context: this,
      generator: function* (maskMeetingNames) {
        this.roombaMetrics.trackEvent(`mask_meeting_names_${this.room.maskMeetingNames ? 'enabled' : 'disabled'}`, {
          room: this.room.id
        });
        try {
          yield this.graphql.updateRoomConfig({
            id: this.room.id,
            maskMeetingNames
          });
          this.flashMessages.showAndHideFlash('success', 'Saved!');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', 'Error saving configuration changes');
        }
      }
    }), {
      drop: true
    }, "toggleMaskMeetingNamesSettingTask", null));
    _defineProperty(this, "toggleRoomClaimabilityTask", _buildTask(() => ({
      context: this,
      generator: function* (claimable) {
        this.roombaMetrics.trackEvent(`impromptu_meetings_${claimable ? 'enabled' : 'disabled'}`, {
          room: this.room.id
        });
        try {
          yield this.graphql.updateRoomConfig({
            id: this.room.id,
            claimable
          });
          this.flashMessages.showAndHideFlash('success', 'Saved!');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', 'Error saving configuration changes');
        }
      }
    }), {
      drop: true
    }, "toggleRoomClaimabilityTask", null));
  }
  get backLink() {
    return this.linkManager.createUILink({
      route: 'roomba.list'
    });
  }
  get maskMeetingNamesSettingActive() {
    return !!this.featureConfig.isEnabled('roomMeetings.maskNames');
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "linkManager", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "roombaMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "roomsPolling", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "featureConfig", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "room", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { RoombaRoomController as default };